var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PageSize"},[_c('label',{attrs:{"for":"pageSize"}},[_vm._v("Regels per pagina")]),_c('b-form-select',{attrs:{"id":"pageSize","disabled":_vm.pageSizeOptions.length === 1,"options":_vm.pageSizeOptions},model:{value:(_vm.pageSize),callback:function ($$v) {_vm.pageSize=$$v},expression:"pageSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }